import { render, staticRenderFns } from "./NewQuotation.vue?vue&type=template&id=71990bc8"
import script from "./NewQuotation.vue?vue&type=script&lang=js"
export * from "./NewQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports